import { render, staticRenderFns } from "./ValueUnitTips.vue?vue&type=template&id=971e7fb2&scoped=true"
import script from "./ValueUnitTips.vue?vue&type=script&lang=js"
export * from "./ValueUnitTips.vue?vue&type=script&lang=js"
import style0 from "./ValueUnitTips.vue?vue&type=style&index=0&id=971e7fb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971e7fb2",
  null
  
)

export default component.exports